import clsx from "clsx";
import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import Paragraph from "../Article/Paragraph";
import Paragraphs from "../Article/Paragraphs";
import Link from "../../utils/Link";

import "./style.scss";
import { buildURLForArticle } from "../../utils/buildURL";

export const ArticleTable = ({ data }) => {
  const { rows = [] } = data;
  const { lang } = useContext(LanguageContext);

  return (
    <div>
      <div class="grid-container">
        {rows.map(({ articles: row = [] }) => {
          return (
            <>
              {row.map(({article}) => {
                {
                  return article ? (
                    <div class="grid-item">
                      <Link to={buildURLForArticle(article)}>{text(article.title, lang)}</Link>
                    </div>
                  ) : (
                    <div></div>
                  );
                }
              })}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ArticleTable;
